import { MEXICO_PROVINCES } from "_common/regions/regions";
import { TAttraction } from "../attractions";
import { ATTRACTION_TYPE } from "_common/attractions/type/attraction.type";

export const guanajuatoAttraction: TAttraction[] = [
    {
        name: "Del Bajío International Airport (BJX)",
        region: MEXICO_PROVINCES.GTO,
        coordinates: {
            lat: 20.9859447,
            lng: -101.481524,
        },
        type: ATTRACTION_TYPE.AIRPORT,
    },
];
